const CERT_CLASS_KEY = 'certClass';

export const getCertClass = () => {
  return localStorage.getItem(CERT_CLASS_KEY);
};

export const setCertClass = (value: string) => {
  localStorage.setItem(CERT_CLASS_KEY, value);
};
